import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { DeleteUtteranceArgs, UpdateUtteranceArgs } from "../types"

export const utteranceMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateUtteranceArgs }) => {
			await tx.mutate.transcriptUtterances.update({
				id: args.id,
				text: args.text,
				contactId: args.speakerId,
			})
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteUtteranceArgs }) => {
			// Soft delete by setting isDeleted: true
			await tx.mutate.transcriptUtterances.update({
				id: args.id,
				isDeleted: true,
			})
		},
	),
}
